import moment from "moment";

const convertToLocalISODateTime = (dateTime, callback) => {
  var tzoffset = new Date(dateTime).getTimezoneOffset() * 60000;
  var localISOTime = new Date(Date.parse(dateTime) - tzoffset).toISOString();
  if (callback) callback(localISOTime);
};

function getDateOnly(dateTimeString) {
  if (!dateTimeString || dateTimeString === null || dateTimeString === "") {
    return "-";
  }
  return moment(dateTimeString).format("DD-MM-YYYY");
}

function formatCurrency(value) {
  const number = Number(value);
  if (isNaN(number)) {
    throw new Error(
      "Invalid input: Please enter a valid number or a string representing a number.",
    );
  }

  return number.toLocaleString("en-US");
}

export { convertToLocalISODateTime, getDateOnly, formatCurrency };
